import { DefaultTheme } from 'styled-components';
import { Colors } from '../components/styles/Colors';

export const theme: DefaultTheme = {
  colors: {
    primaryLightColor: Colors.Lime,
    primaryDarkColor: Colors.Purple,
  },
};
